import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
import { testimonials } from '../data/content';
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-206" data-mp="3fz5nrwzgtig9">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-207" data-mp="3azjcvu740eam" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <Section emoji="⭐" eyebrow="4.9/5 · 1,200+ physicians" title="What physicians are saying" data-id="element-208" data-mp="31zwc9am7fcim">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-209" data-mp="2x09z116dlw9t">
        {testimonials.map(t => <figure key={t.name} className="flex h-full flex-col rounded-3xl border border-navy/8 bg-cream p-4 shadow-sm sm:p-5" data-id="element-210" data-mp="2s28h4jkos2zx">
            <Stars data-id="element-211" data-mp="v72gzjzdp0k8" />
            <blockquote className="mt-3 flex-1 text-[14.5px] leading-snug text-navy/80 sm:text-[15px]" data-id="element-212" data-mp="qall23lxthwl">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-4 flex items-center gap-3 border-t border-navy/8 pt-4" data-id="element-213" data-mp="h4n2y9bp5v9v">
              <img src={t.photo} alt={`Portrait of ${t.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-214" data-mp="m6m5jgzm4o5r" />
              <div className="min-w-0" data-id="element-215" data-mp="c8y282nxy8bz">
                <p className="text-[14px] font-bold text-navy" data-id="element-216" data-mp="zvwgctol946q">
                  {t.name} <span aria-hidden="true" data-id="element-217" data-mp="14vj3buu7xysq">{t.flag}</span>
                </p>
                <p className="text-[12px] text-navy/55" data-id="element-218" data-mp="14uragrs0af65">{t.role}</p>
              </div>
            </figcaption>
          </figure>)}
      </div>

      <div className="mx-auto mt-8 max-w-md" data-id="element-219" data-mp="v4xw5j0hbly7">
        <CTAButton label="Join 1,200+ physicians" sublabel="Instant access · 7-day guarantee" data-id="element-220" data-mp="v3wh73gcefb7" />
      </div>
    </Section>;
}